/**
 * Application Configuration
 * All environment variables and global constants should be accessed through this file.
 */

interface Config {
  api: {
    baseUrl: string;
    timeout: number;
  };
  app: {
    name: string;
    baseUrl: string;
    isDev: boolean;
    isProd: boolean;
  };
  storage: {
    accessTokenKey: string;
    refreshTokenKey: string;
  };
}

const config: Config = {
  api: {
    // In development, we use the proxy set up in vite.config.ts
    // In production, we use the environment variable or default to /api/v1
    baseUrl: import.meta.env.VITE_API_URL || '/api/v1',
    timeout: 30000,
  },
  app: {
    name: import.meta.env.VITE_APP_NAME || 'RaazGold Panel',
    baseUrl: import.meta.env.BASE_URL,
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
  },
  storage: {
    accessTokenKey: 'raaz_access_token',
    refreshTokenKey: 'raaz_refresh_token',
  },
};

export default config;
